<template>
  <div class="content-builder">
    <div class="form-group">
      <label class="control-label" for="question_text">Menu Text</label>
      <QuillEditor v-model:content="content.question.text" :contentType="'html'" :modules="editorModules"
                   :toolbar="toolbarOpts"
                   theme="snow"/>
    </div>
    <div class="form-group">
      <label class="control-label" for="question-text-classes">Menu Text CSS Classes</label>
      <input id="question-text-classes" v-model="content.questionTextClasses" class="form-control" type="text">
    </div>
    <div class="form-group">
      <label class="control-label">Menu Image</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <a class="btn btn-primary text-white" data-input="question-image" data-lfm="image">
            <i class="fa fa-image"></i>
          </a>
        </div>
        <input id="question-image" v-model="content.questionImage" class="form-control" type="text">
      </div>
    </div>
    <AnimationControlsComponent :content="content"></AnimationControlsComponent>
    <div class="form-group">
      <div class="actions">
        <div class="action-item">
          <button class="btn btn-default" type="button"
                  @click="addResponse"><i class="fa fa-plus"></i> Add Menu Item
          </button>
        </div>
      </div>
      <div class="content-list">
        <div v-for="(response, index) in content.question.responses" v-cloak :key="index"
             class="card content-list-item">
          <div class="card-header text-center font-weight-bold">{{ alphabet[index] }}</div>
          <div class="card-body">
            <div class="choice-wrap mb-2">
              <div class="col pl-0 pr-0 choice-input">
                <label class="control-label" for="label">Choice Text</label>
                <QuillEditor v-model:content="content.question.responses[index].label" :contentType="'html'"
                             :options="editorOpts"/>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-sm-6">
                <label class="control-label" for="feedback-image">Choice Image</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <a :data-input="'feedback-image-' + index" class="btn btn-primary text-white"
                       data-lfm="image">
                      <i class="fa fa-image-o"></i> Choose
                    </a>
                  </div>
                  <input :id="'feedback-image-' + index" v-model.lazy="response.image" class="form-control"
                         type="text">
                </div>
              </div>
              <div class="col-sm-6">
                <label class="control-label" for="flow">Flow Hook</label>
                <input v-model="response.flow" :placeholder="'choice-' + (index + 1)" class="form-control"
                       type="text">
              </div>
            </div>
            <div class="form-group row justify-content-end">
              <div class="col-3">
                <button class="btn btn-danger btn-block btn-remove" type="button"
                        @click="remove(response, index)">Remove
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="content.question.responses.length > 0">
        <div class="action-item">
          <button class="btn btn-default" type="button"
                  @click="addResponse"><i class="fa fa-plus"></i> Add Menu Item
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import {defaultMeters} from '../../../common/metrics'
import layoutMixin from '../../mixins/layout'
import AnimationControlsComponent from "../AnimationControlsComponent.vue"
import {EDITOR_CONFIG_BUTTONS_FULL, EDITOR_CONFIG_LITE} from '../../../common/constants'
import {QuillEditor} from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

export default {
  components: {QuillEditor, AnimationControlsComponent},
  mixins: [layoutMixin],
  data() {
    const content = _.cloneDeep(this.source)
    let filled = _.defaults(content, {
      question: {
        text: '',
        timeLimit: false,
        responses: [],
        animationEffects: {
          responseDisplay: '',
          responseStartDelay: 0,
          responseBetweenDelay: 0.2
        },
        questionTextClasses: '',
      }
    })

    if (!_.get(filled.question, 'questionTextClasses')) {
      filled.question.questionTextClasses = ''
    }

    if (!_.get(filled.question, 'animationEffects')) {
      filled.question.animationEffects = {
        responseDisplay: '',
        responseStartDelay: 0,
        responseBetweenDelay: 0.2
      }
    }

    return {
      content: filled,
      toolbarOpts: EDITOR_CONFIG_BUTTONS_FULL,
      editorOpts: EDITOR_CONFIG_LITE
    }
  },
  computed: {
    comboScores() {
      return this.content.question.comboScores
    },
    defaultComboOpts() {
      let opts = []
      this.content.question.responses.forEach((response, index) => {
        opts.push({value: false})
      })
      return opts
    }
  },
  methods: {
    getValue() {
      _.each(this.content.question.responses, (response, key) => {
        this.content.question.responses[key].image = $("#feedback-image-" + key).val()
      })
      _.each(this.content.question.comboScores, (comboScore, key) => {
        comboScore.generateFeedback = false
        comboScore.showRegenerateButton = false
      })
      return this.content
    },
    remove(item, index) {
      this.content.question.responses.splice(index, 1)
    },
    addResponse() {
      this.content.question.responses.push({
        meters: defaultMeters()
      })
    },
  }
}
</script>

<style lang="scss">
.choice-wrap .ql-container {
  height: auto !important;
  margin-bottom: 1rem;
}

.content-list {
  clear: both;

  .form-group {

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.actions {
  align-items: flex-start;
}

</style>
